<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="session">
        <div class="session-expired">
          <div class="session-expired_content">
            <img class="session-expired_content__icon" src="../../assets/icons/DesktopWarning.svg" alt="info" />
            <span class="title session-expired_topSpacing"> Session expired </span>
            <p class="session-expired_content__info">
              We’re sorry but your session has expired. Kindly go back to merchant’s site & checkout again with Zero.
            </p>

            <div class="session-expired_content__badge">Your zero account has not been charged</div>
          </div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script lang="ts" setup>
import Popup from '@/components/cards/popup/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'

const close = () => {
  store.actions.setCheckAccess(false)
}
const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}
</script>
